<template>
  <v-container>
    <v-data-table-server
      v-model:items-per-page="pagination.limit"
      :items="orders"
      :headers="headers"
      :items-length="count"
      :loading="loading"
      item-key="id"
      @update:options="handleLimitChange">
      <template v-slot:[`item.action`]="{ item }">
        <v-btn
          :to="{ name: 'OrderDetail', params: { orderId: item.orderId } }"
          router
          small
          color="primary">
          View
        </v-btn>
      </template>
    </v-data-table-server>
  </v-container>
</template>
<script setup lang="ts">
import { IOrderDTO, IPaginationDTO, PaginationDTO } from '@/dtos';
import { useOrderStore } from '@/stores';
import { computed, ref } from 'vue';
import type { VDataTableServer } from 'vuetify/components';

const pagination = ref<IPaginationDTO>(new PaginationDTO());
const orderStore = useOrderStore();
const { data: orderData, isLoading: isLoadingOrders } = orderStore.getMyOrdersQuery(pagination);

const orders = computed(() => orderData.value?.data as IOrderDTO[]);
const count = computed(() => orderData.value?.count ?? 0);
const loading = computed(() => isLoadingOrders.value);
const headers = [
  { title: 'Order Id', key: 'orderId' },
  { title: 'Year', key: 'productVariant.product.year.year', sortable: true },
  {
    title: 'Registration Level',
    key: 'productVariant.product.teamLevel.team_level',
    sortable: true,
  },
  { title: 'Actions', key: 'action', sortable: false },
];

const handleLimitChange = async (value: VDataTableServer) => {
  pagination.value.buildPagination(value);
};
</script>
